import { Content } from '@amzn/awscat-pattern-library-service-model';
import type { JSONContent } from '@tiptap/core';
import { enumeratePages } from '../PageOperations';
import { DEFAULT_TYPES_FOR_UNIQUE_ID } from '@amzn/awscat-editor';

function hasMissingNodeId(node: JSONContent | undefined): boolean {
  if (!node) return false;
  if (DEFAULT_TYPES_FOR_UNIQUE_ID.includes(node.type ?? '') && !node.attrs?.nodeId) return true;
  return node.content?.some(hasMissingNodeId) ?? false;
}

/**
 * Returns true when any page or section body in the guide has a
 * UniqueId-tracked node missing a `nodeId`.
 */
export function hasAnyMissingNodeId(content: Content): boolean {
  for (const page of enumeratePages(content)) {
    if (hasMissingNodeId(page.contentData)) return true;
    for (const section of page.contentSections ?? []) {
      if (hasMissingNodeId(section.contentData)) return true;
    }
  }
  return false;
}
